import * as React from 'react';

import { useTracking } from '@xing-com/crate-communication-tracking';

export type AdobePageViewTrackerProps = {
  trackingChannel?: string;
  pageName?: string;
};

export const AdobePageViewTracker: React.VFC<AdobePageViewTrackerProps> = ({
  trackingChannel,
  pageName,
}) => {
  const { track } = useTracking();

  React.useEffect(() => {
    if (trackingChannel && pageName) {
      track({
        type: 'pageview',
        channel: trackingChannel,
        page: pageName,
      });
    }
  }, [pageName, trackingChannel, track]);

  return <></>;
};
